import React, { FC, Fragment } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import format from 'date-fns/format';

import Box from '@mui/material/Box';
import ArrowIcon from '@mui/icons-material/ArrowRightAlt';

import { FlightShortDetailsSegments_segments$key } from '__generated__/FlightShortDetailsSegments_segments.graphql';

type Props = {
  showTime?: boolean;
  segments: FlightShortDetailsSegments_segments$key;
};

const Segments: FC<Props> = props => {
  const { showTime = true } = props;

  const segments = useFragment(
    graphql`
      fragment FlightShortDetailsSegments_segments on FlightSegmentType
      @relay(plural: true) {
        id
        departDatetime
        departAirportCode
        arrivalAirportCode
      }
    `,
    props.segments
  );

  const lastSegment = segments[segments.length - 1];

  return (
    <Box sx={{ display: 'flex' }}>
      {segments[0] &&
        showTime &&
        format(new Date(segments[0].departDatetime), 'yyyy-MM-dd HH:mm')}{' '}
      {segments.map(segment => (
        <Fragment key={segment.id}>
          {segment.departAirportCode}
          <ArrowIcon sx={{ marginTop: '-3px' }} />
        </Fragment>
      ))}
      {lastSegment && lastSegment.arrivalAirportCode}
    </Box>
  );
};

export default Segments;
